/* unplugin-vue-components disabled */import { render } from "./memory.vue?vue&type=template&id=298d02e7&scoped=true"
import script from "./memory.vue?vue&type=script&lang=js"
export * from "./memory.vue?vue&type=script&lang=js"

import "./memory.vue?vue&type=style&index=0&id=298d02e7&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298d02e7"],['__file',"src/pages/settings/memory/memory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "298d02e7"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('298d02e7', __exports__)) {
    api.reload('298d02e7', __exports__)
  }
  
  module.hot.accept("./memory.vue?vue&type=template&id=298d02e7&scoped=true", () => {
    api.rerender('298d02e7', render)
  })

}


export default __exports__